import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=df4d0ce8"
import script from "./Review.vue?vue&type=script&lang=ts"
export * from "./Review.vue?vue&type=script&lang=ts"
import style0 from "./Review.vue?vue&type=style&index=0&id=df4d0ce8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports